(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const observedRoots = new WeakSet();
  const observedActivators = new WeakSet();

  const positionChatActivator = () => {
    const chat = document.querySelector('shopify-chat');
    const shadowRoot = chat?.shadowRoot;
    const activatorNudge = shadowRoot?.querySelector('.activator-nudge');
    const activator = shadowRoot?.querySelector('.activator');
    const activatorLabel = shadowRoot?.querySelector('.activator__label');
    if (!activatorNudge || !activator || !activatorLabel) return false;

    if (!observedRoots.has(shadowRoot)) {
      observedRoots.add(shadowRoot);
      new MutationObserver(() => requestAnimationFrame(positionChatActivator)).observe(shadowRoot, {
        childList: true,
        subtree: true,
      });
    }

    if (!observedActivators.has(activator)) {
      observedActivators.add(activator);
      new ResizeObserver(() => requestAnimationFrame(positionChatActivator)).observe(activator);
    }

    if (mobileQuery.matches) {
      // The round launcher owns mobile placement, including safe-area/preview offsets.
      activatorNudge.style.removeProperty('right');
      activatorNudge.style.removeProperty('bottom');
    } else {
      activatorNudge.style.removeProperty('bottom');
      activatorNudge.style.setProperty(
        'right',
        'calc(var(--shopify-agent-activator-offset, 20px) + 20px)',
        'important',
      );
    }

    activatorLabel.style.setProperty('white-space', 'nowrap', 'important');

    return true;
  };

  const initialize = () => {
    if (positionChatActivator()) return;

    const observer = new MutationObserver(() => {
      if (positionChatActivator()) observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  };

  document.addEventListener('DOMContentLoaded', initialize);
  window.addEventListener('resize', positionChatActivator);
  mobileQuery.addEventListener('change', positionChatActivator);
})();
